import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Helmet} from "react-helmet";

import announcerStore from './AnnouncerStore';

class DocumentTitle extends Component {
    constructor(props) {
        super(props);
        this.props = props;
    }

    componentDidMount() {
        announcerStore.announce(`Navigate to ${this.props.title}`)
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>{this.props.title}</title>
                </Helmet>
                {this.props.children}
            </>
        );
    }
}

DocumentTitle.propTypes = {
    title: PropTypes.string.isRequired
}

export default DocumentTitle;